export const NEW_PROJECT_CATEGORY = {
  DEFAULT: 'Default Project',
  CHROMAKEY: 'Solid Background',
  PPT: 'PPT to Video',
} as const;
export type NewProjectCategory = (typeof NEW_PROJECT_CATEGORY)[keyof typeof NEW_PROJECT_CATEGORY];

export const DASHBOARD_PROJECT_TYPE = {
  DEFAULT: 'default',
  CHROMAKEY: 'chromakey',
} as const;
export type DashboardProjectType = (typeof DASHBOARD_PROJECT_TYPE)[keyof typeof DASHBOARD_PROJECT_TYPE];

export const QUICK_TEMPLATES_CATEGORY = {
  CUSTOM_AVATAR: 'customavatar',
  DREAM_AVATAR: 'dreamavatar',
  VIDEO_MESSAGE: 'send2Groups',
  TOPIC_TO_VIDEO: 'topic2Video',
  ARTICLE_TO_VIDEO: 'article2Video',
  DOCS_TO_VIDEO: 'docs2Video',
  SERIES_OF_VIDEOS: 'videoseries',
  IMPORT_PPT: 'ppt',
  URL_TO_VIDEO: 'url2Video',
  CHROMAKEY_EDITOR: 'chromakey',
  DEFAULT_TEMPLATE: 'default',
  SCREEN_RECORDING: 'screenRecording',
  AUTO_CAPTION: 'autoCaption',
  VIDEO_TRIM_MERGE_CROP: 'videoTrim',
  AI_VOICE_GENERATOR: 'voiceGenerator',
  TEXT_GENERATOR: 'textGenerator',
  VIDEO_GENERATOR: 'videoGenerator',
  SOCIAL_MEDIA_DOWNLOADER: 'snsDownloader',
  VIDEO_CONVERTER: 'videoConverter',
  AUDIO_CONVERTER: 'audioConverter',
  VOICE_CLONING: 'voiceCloning',
  VIDEO_TRANSLATION: 'videoTranslation',
  VIDEO_HIGHLIGHTS: 'videoHighlights',
  IMAGE_GENERATOR: 'imageGenerator',
  AI_AVATAR_CARD: 'send2GroupsB2B',
} as const;
export type QuickTemplatesCategory = (typeof QUICK_TEMPLATES_CATEGORY)[keyof typeof QUICK_TEMPLATES_CATEGORY];